import { useAuthStore } from './auth';
import { isStaleOrExpired } from './jwt-claims';

interface RefreshResponse {
  access_token: string;
  expires_in?: number;
  token_type?: string;
}

/**
 * Runs once on app boot. If we hydrated a stale/expired access token from
 * localStorage, swap it for a fresh one via the HttpOnly refresh cookie BEFORE
 * any protected query fires. Best-effort: silent failure here just defers to
 * the lazy 401-handler in api.ts, which will redirect to /login when the first
 * protected request fails.
 */
export async function bootstrapAuth(): Promise<void> {
  const { accessToken } = useAuthStore.getState();
  if (!accessToken) return;
  if (!isStaleOrExpired(accessToken)) return;

  try {
    const res = await fetch('/v1/auth/refresh', {
      method: 'POST',
      credentials: 'include',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return;
    const body = (await res.json()) as RefreshResponse;
    if (body.access_token) {
      useAuthStore.setState({ accessToken: body.access_token });
    }
  } catch {
    // Network failure during boot — let lazy handler deal with it later.
  }
}
